<template>
  <v-container class="WorkFlow">


    <template v-for="(rows,idx) in listMenu">

    <div style="padding: 10px;" :key="idx">

      <a v-if="rows.menuUrl !=''" style="text-decoration: none;" :href="rows.menuUrl" target="_blank">

        <v-card
              v-ripple 
              class="mx-auto "
              style="border-radius: 10px;"
              color=""
              max-width="400"
           
        >
          <!-- <v-card-title color="#000">
            <h1 style="color: white;">{{ rows.menuHeaderName }}</h1>
          </v-card-title> -->
         <v-card-actions>
        <v-list-tile class="grow">
          <v-list-tile-avatar >
            <v-img
              :src="require(`@/assets/img/${rows.pathicon}`)"
            ></v-img>
          </v-list-tile-avatar>
          <v-list-tile-content class="mx-auto mt-3">
            <span class="title font-weight-bold">{{  rows.menuHeaderName }}</span>
          </v-list-tile-content>
           
        </v-list-tile>
      </v-card-actions>
     </v-card>

      </a>

      <a v-else style="text-decoration: none;" href="javascript:void(0);" @click="showSubMenu(rows.id);">
        <v-card
              v-ripple 
              class="mx-auto "
              style="border-radius: 10px;"
              color=""
              max-width="400"
           
        >
         <v-card-actions>
        <v-list-tile class="grow">
          <v-list-tile-avatar >
            <v-img
              :src="require(`@/assets/img/${rows.pathicon}`)"
            ></v-img>
          </v-list-tile-avatar>
          <v-list-tile-content class="mx-auto mt-3">
            <span class="title font-weight-bold">{{  rows.menuHeaderName }}</span>
          </v-list-tile-content>
           
        </v-list-tile>
      </v-card-actions>
     </v-card>
      </a>

      <span v-for="(rows2,idx2) in rows.subMenuList">
        <div :class="'hide-div div-sub-menu div-set'+rows.id" :ref="'divSubMenu'+rows.id" style="padding: 5px;" :key="rows2.sid">
          <a target="_blank" :href="rows2.urlMenu" style="color: white; text-decoration: none;">
            <!-- <v-card
                color="#1976d2"
            >
              <v-card-title color="#000">
                  <h3 style="color: white;">{{rows2.nameMenu}}</h3>
              </v-card-title>
            </v-card> -->
             <v-card
              v-ripple 
              class="mx-auto "
              style="border-radius: 10px;"
              max-width="400"
        >
         <v-card-text>
            <span >{{  rows2.nameMenu }}</span>
      </v-card-text>
     </v-card>
          </a>
        </div>
      </span>

    </div>

    </template>  



  </v-container>
</template>

<script>
export default {
  name: "WorkFlow",
  data: () => ({
    listMenu: [
      {
        id: "1",
        menuHeaderName: "Corporation",
        menuUrl: "",
        pathicon : "w_corporation.png",
        subMenuList: [
          {
            sid: "1",
            nameMenu: "Memo",
            urlMenu: "https://forms.office.com/r/M0nKe48khy",
          },
          {
            sid: "2",
            nameMenu: "ขอทำนามบัตร",
            urlMenu: "https://forms.office.com/r/BW8paduStT",
          }
        ]
      },
      {
        id: "2",
        menuHeaderName: "SAL",
        menuUrl: "",
        pathicon : "w_sales.png",
        subMenuList: [
          {
            sid: "1",
            nameMenu: "ฟอร์มเปลี่ยนชื่อผู้จอง/เปลี่ยนมือ (SAL-CO)",
            urlMenu: "https://forms.office.com/r/zxQF7cDCGv",
          },
          {
            sid: "2",
            nameMenu: "ฟอร์มเปลี่ยนที่อยู่/ที่ติดต่อ/เบอร์โทร/E-Mail (SAL-CA)",
            urlMenu: "https://forms.office.com/r/qgX4mk7Adw",
          },
          {
            sid: "3",
            nameMenu: "ฟอร์มขอเปลี่ยนผลิตภัณฑ์ / โครงการ / เพิ่ม-ลด เฟอร์นิเจอร์ (SAL-CU)",
            urlMenu: "https://forms.office.com/r/Kgka8hTh9t",
          },
          {
            sid: "4",
            nameMenu: "ฟอร์มขอเปลี่ยนแปลงการชำระค่างวด (SAL-CP)",
            urlMenu: "https://forms.office.com/r/kcds6LDe85",
          },
          {
            sid: "5",
            nameMenu: "ฟอร์มขอยกเลิกสัญญาจอง (SAL-CB)",
            urlMenu: "https://forms.office.com/r/tFmsDvrK2p",
          },
          {
            sid: "6",
            nameMenu: "ฟอร์มขอยกเลิกสัญญาจะซื้อจะขาย (SAL-CC)",
            urlMenu: "https://forms.office.com/r/RTJQPEChYr",
          },
        ]
      },
      {
        id: "3",
        menuHeaderName: "MIS",
        menuUrl: "https://forms.office.com/r/WFSDMC4bFx",
        pathicon : "w_mis.png",
        subMenuList: []
      }
    ],
  }),
  methods: {
    showSubMenu: function(p){


      let obj_all = document.getElementsByClassName('div-sub-menu');
      let loop_all = obj_all.length;
      let x;
      for(x = 0; x <loop_all; x++){
        obj_all[x].classList.add("hide-div");
        //console.log(obj_all[x].classList);

      }


      let obj = document.getElementsByClassName('div-set'+p);
      let loop = obj.length;
      if(loop > 0){
        let i;
        for(i = 0 ; i < loop; i++){
          obj[i].classList.remove("hide-div");
        }
      }



    }
  }
}
</script>

<style scoped>
  .hide-div{
    display: none;
  }

  .div-sub-menu{
    margin-left: 20px;
  }
</style>